export default __webpack_public_path__ + "static/media/ic_gift.1d787b5d.svg";